import { Component, Vue, Prop, Watch } from 'vue-property-decorator';
import ASpaceInBetweenAnother from '../../shared/ASpaceInBetweenAnother/a.space.inbetween.another.vue';

@Component({
    components: {
        ASpaceInBetweenAnother
    }
})
export default class EpicCarousel extends Vue {
    public title: string = 'EpicCarousel';

    @Prop({ default: '200px' })
    public height: any;

    @Prop({ default: undefined })
    public data: any;

    @Watch('data', { immediate: true, deep: true })
    public onDataInput(val: any, oldVal: any) {
    }

    public nav() {
        window.open('http://queenfinancial.ca/');
    }
}
